import { FC, ReactNode, useState } from 'react'
import clsx from 'clsx'
import { MagnifyImage } from '../../../magnify-image/MagnifyImage'
import { VideoSlide, VideoSlidesController } from '../../../articles'
import { ContentItem } from '@obeta/data/lib/hooks/useArticleGalleryContent'
import { ThreeDImageContainer } from '../threeDImageContainer/ThreeDImageContainer'
import styles from './ContentViewer.module.scss'

type ContentViewerProps = {
  activeItem: ContentItem
}

export const ContentViewer: FC<ContentViewerProps> = ({ activeItem }) => {
  const [imageFullContainerMode, setImageFullContainerMode] = useState(false)

  let content: ReactNode = null

  const onZoomIntrospect = (zoomLvl: number | null) => {
    if (zoomLvl === null) setImageFullContainerMode(false)

    if (zoomLvl === 0) setImageFullContainerMode(true)
  }

  if (activeItem.contentType === 'oxomi3DImage') {
    content = <ThreeDImageContainer activeItem={activeItem} />
  }

  if (activeItem?.contentType === 'image') {
    content = (
      <MagnifyImage
        src={activeItem.url}
        alt={activeItem.description}
        className={clsx(styles.MagnifyImage, {
          [styles.imageFullContainerMode]: imageFullContainerMode,
        })}
        zoomMode="click"
        onZoomIntrospect={onZoomIntrospect}
        zoomScale={[1, 2]}
      />
    )
  }

  if (activeItem?.contentType === 'video') {
    content = (
      <div className={styles.videoWrapper}>
        <VideoSlidesController>
          <VideoSlide {...activeItem} poster={activeItem.thumbUrl} />
        </VideoSlidesController>
      </div>
    )
  }

  return <div className={styles.contentViewer}>{content}</div>
}
